import { Box, Button } from "@mui/material";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { InitialUserEdit, InterfaceUserEdit } from "../data/user.interface";
import FormText from "../../../shared/form/FormText";
import { useDispatch } from "react-redux";
import { createUser, editUser, getUser } from "../data/user.api";
import alertSuccess from "../../../shared/alert/alertSuccess";
import RoleSelect from "../../role/components/RoleSelect";
import FormPassword from "../../../shared/form/FormPassword";

export default function UserForm(props: { mode: "ADD" | "EDIT", data?: InterfaceUserEdit, onSubmit: () => void }) {

    const dispatch = useDispatch<any>()

    const [values, setValues] = useState<InterfaceUserEdit>(InitialUserEdit)

    useEffect(() => {
        if (props.data !== undefined) {
            setValues(props.data)
        }
    }, [props.data])

    const handleChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
        const { name } = e.target
        let value = ["price"].includes(name) ? parseInt(e.target.value) : e.target.value
        setValues(last => ({
            ...last,
            [name]: value
        }))
    }

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault()
        try {
            if (props.mode === "ADD") {
                await dispatch(createUser(values)).unwrap()
                await alertSuccess("Berhasil menyimpan data")
            }
            else if (props.mode === "EDIT") {
                await dispatch(editUser(values)).unwrap()
                await alertSuccess("Berhasil mengubah data")
            }
            setValues(InitialUserEdit)
            dispatch(getUser())
            props.onSubmit()
        } catch (error) { }
    }

    return (
        <Box>
            <form onSubmit={handleSubmit}>
                <FormText label="Username" name="username" value={values.username} required onChange={handleChangeValues} />
                <FormPassword label="Password" name="password" value={values.password} required onChange={handleChangeValues} />
                <RoleSelect value={values.role_id} onChange={(value) => setValues(last => ({ ...last, role_id: value }))} />
                <Box marginTop={1} display={"flex"} justifyContent={"flex-end"}>
                    <Button type="submit">Simpan</Button>
                </Box>
            </form>
        </Box>
    )
}